<template>
  <div></div>
</template>

<script>

import { mapActions } from 'vuex'

export default {

  methods: {

    ...mapActions('user', ['doLogout']),

    async logout () {
      try {
        await this.doLogout()
      } catch (error) {
        console.log(error)
        alert('Somehting Went Wrong !')
      } finally {
        this.$root.$bvToast.toast('Signed Out', {
            title: 'Success',
            autoHideDelay: 3000,
            variant: 'success',
          })
        this.$router.push({ name: 'login' })
      }
    }
  },

  mounted () {
    this.logout()
  }

}

</script>
